import { Component, Input, OnInit, SimpleChanges, OnChanges, EventEmitter, Output, OnDestroy, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';
import { SelectFieldComponent } from '../../../../components/form/select-field/select-field.component';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProposalsService } from '../../../../services/api/proposals.service';
import { NgbAlert, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { FormService } from '../../../../services/form.service';
import { SwitchFieldComponent } from '../../../../components/form/switch-field/switch-field.component';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { OptionService } from 'src/app/services/api/option.service';
import { HttpParams } from '@angular/common/http';
import { CampaignsService } from 'src/app/services/api/campaigns.service';
import { LoaderComponent } from 'src/app/components/widgets/loader/loader.component';
import { LoaderConfig } from 'src/app/components/widgets/loader/loader.config';
import { LoaderService } from 'src/app/services/loader.service';
import { Subscription } from 'rxjs';
import { ItemsService } from 'src/app/services/api/general-settings/items.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { AccessControlService } from '../../../../services/access-control.service';

@Component({
  selector: 'proposals-items',
  imports: [CommonModule, SelectFieldComponent, InputFieldComponent, ReactiveFormsModule, NgbAlert, SwitchFieldComponent, FormsModule, LoaderComponent],
  templateUrl: './proposals-items.component.html',
  styleUrls: ['./proposals-items.component.scss']
})
export class ProposalsItemsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('proposalItemsContainer') proposalItemsContainer!: ElementRef;
  @ViewChild('detailsModal') private detailsModal!: TemplateRef<unknown>;
  @ViewChild('discountNoteModal') private discountNoteModal!: TemplateRef<unknown>;
  private discountNoteModalRef?: NgbModalRef;
  @Input() readonlyItems: boolean = false;
  @Input() items?: any[] = [];
  @Input() verificed: boolean = false;
  @Input() useDetailView: boolean = false;
  @Input() proposal?: any = null;
  @Input() proposalId: any = null;
  @Input() isOverdiscountApprovalState: boolean = false;
  @Input() isTechApprovalState: boolean = false;
  @Input() isItemsLocked: boolean = false;
  @Input() targetExchangeRate: number | null = null;
  @Input() targetCurrencyLabel: string | null = null;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();
  @Output() statusChange = new EventEmitter<string>();
  @Output() verificationChanged = new EventEmitter<boolean>();
  @Output() overdiscountVerificationChanged = new EventEmitter<boolean>();
  @Output() discountWarningChanged = new EventEmitter<{hasWarning: boolean, allJustified: boolean}>();
  @Output() itemsChangedState = new EventEmitter<boolean>();
  @Output() techApprovalVerificationChanged = new EventEmitter<boolean>();

  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  expandedItems: { [key: number]: boolean } = {};
  missingLawsByItem: { [itemIndex: number]: boolean } = {};

  discountWarningData: {
    currentDiscount?: number;
    maxDiscount?: number;
    campaignName?: string;
    itemIndex?: number;
  } | null = null;

  discountJustification: string = '';
  currentItemWithWarning: AbstractControl | null = null;

  formItems!: FormGroup;
  itemToBeDeleted!: FormArray;
  indexItemToBeDeleted: number = 0;
  deleteType: 'item' | 'law' = 'item';

  jurisdictionsOptions: { key: string; value: string }[] = [];

  itemProductsOptions: { key: number; value: string }[] = [];
  itemTypesOptions: { key: number; value: string }[] = [];
  lawsOptions: { key: number; value: string; jurisdictionId: number }[] = [];
  platformOptions: { key: string; value: string }[] = [];
  campaignsOptions: { key: string; value: string }[] = [];

  itemSpecificOptions: {
    [itemId: number]: {
      products: { key: number; value: string }[];
      types: { key: number; value: string }[];
    }
  } = {};

  lawOptionsByItem: {
    [itemIndex: number]: { key: number; value: string }[];
  } = {};

  private itemLawJurisdiction: { [itemIndex: number]: string } = {};
  private lawOptionsLoadingByItem: { [itemIndex: number]: boolean } = {};

  campaignsDetails: {
    [campaignId: string]: {
      discountPercent: number;
      name: string;
    }
  } = {};

  private itemMaxDiscountBaseline = new WeakMap<FormGroup, number>();


  typesOptions = [
    { key: 'TOA', value: 'TOA' },
    { key: 'Variant', value: 'Variant' }
  ];


  items$ = new BehaviorSubject<any[] | undefined>(this.items);
  isLoading: boolean = false;
  hasChanges: boolean = false;
  private hasHadItems: boolean = false;
  private isSyncingFormState: boolean = false;
  loaderConfig: LoaderConfig = {
    type: 'spinner',
    text: 'Saving items...',
    overlay: true
  };
  
  private loaderSubscription: Subscription | null = null;
  private readonly LOADER_CONTEXT = 'proposals-items';
  
  saveButtonDisabled: boolean = false;
  private saveButtonSubscription: Subscription | null = null;

  private readonly PRICING_ALLOWED_PROFILES = ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'OFF5', 'CCO', 'CEO1', 'CFO1', 'GM01', 'CTO1'];
  canViewPricingFields: boolean = false;
  canModifyVerifiedSwitch: boolean = false;
  canModifyVerifiedTechSwitch: boolean = false;
  private profileSubscription: Subscription | null = null;

  private readonly PLATFORM_ALLOWED_PROFILES = ['ADM1', 'SAL1', 'SAL2', 'SAL3', 'OFF5', 'CCO', 'CEO1', 'CFO1', 'GM01', 'CTO1'];
  canSeePlatformField: boolean = false;
  private platformProfileSubscription: Subscription | null = null; 

  lawsByJurisdiction: { [jurisdictionId: string]: { key: number, value: string }[] } = {};
  
  private loadingLaws: { [jurisdictionId: string]: boolean } = {};
  
  private loadedJurisdictions: Set<string> = new Set();

  get addItemDisabled(): boolean {
    return this.saveButtonDisabled || this.isItemsLocked;
  }

  get saveItemsDisabled(): boolean {
    return this.saveButtonDisabled || this.isItemsLocked ||
      (this.getItemsArray()?.length ?? 0) === 0;
  }

  constructor(
    private fb: FormBuilder,
    private alertNotificationService: AlertNotificationService, 
    private proposalsService: ProposalsService, 
    private formService: FormService,
    private optionsService: OptionService, 
    private campaignsService: CampaignsService,
    private loaderService: LoaderService,
    private itemsService: ItemsService,
    private confirmationDialogService: ConfirmationDialogService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService,
    private modalService: NgbModal
  ) {
    this.profileSubscription = this.mainLayoutService.activeProfile$.subscribe((profileCode) => {
      this.canViewPricingFields = !!profileCode && this.PRICING_ALLOWED_PROFILES.includes(profileCode);
      this.canModifyVerifiedSwitch = this.accessControlService.hasFeatureActionAccess(profileCode, 'PROPOSALS_SWITCH_VERIFIED', 'modify');
      this.canModifyVerifiedTechSwitch = this.accessControlService.hasFeatureActionAccess(profileCode, 'PROPOSALS_SWITCH_VERIFIED_TECH', 'modify');
    });
    this.alertNotificationService.notifications$.subscribe((notification) => {
      this.alertInfo = {
        show: true,
        type: notification.type === 'error' ? 'danger' : notification.type,
        message: notification.message
      };

      setTimeout(() => {
        this.alertInfo.show = false;
      }, 3000);
    });

    const params = new HttpParams()      
      .set('size', '9999')
      .set('active', 'true');

    this.proposalsService.jurisdictions$.subscribe((jurisdictions: any[]) => {
      this.jurisdictionsOptions = jurisdictions.map(jurisdiction => ({ key: jurisdiction.key, value: jurisdiction.value }));
    });

    this.optionsService.platforms().subscribe({
      next: (response: any) => {
        this.platformOptions = response.data.platforms.map((platform: any) => ({ key: platform.platformId, value: platform.name }));
        this.syncPlatformDefaultsAcrossItems();
      },
      error: (error: any) => {
        console.error('Error loading platforms:', error);
        this.alertNotificationService.error('Error loading platforms');
      }
    });

    this.campaignsService.list({ params }).subscribe({
      next: (response: any) => {
        const campaignOptions = response.data.campaigns.map((campaign: any) => ({ key: campaign.campaignId, value: campaign.name }));
        this.campaignsOptions = [{ key: '', value: '' }, ...campaignOptions];

        response.data.campaigns.forEach((campaign: any) => {
          this.campaignsDetails[campaign.campaignId] = {
            discountPercent: campaign.discountPercent || 0,
            name: campaign.name
          };
        });

        this.getItemsArray()?.controls?.forEach(control => this.applyMaxDiscountForItem(control as FormGroup));
      },
      error: (error: any) => {
        console.error('Error loading campaigns:', error);
        this.alertNotificationService.error('Campaign loading error');
      }
    });

    this.loaderSubscription = this.loaderService
      .getLoadingAsObservable(this.LOADER_CONTEXT)
      .subscribe(isLoading => this.isLoading = isLoading);
  }

  ngOnInit(): void {
    this.items$.next(this.items || []);
    this.formItems = this.fb.group({
      items: this.fb.array([])
    });
    this.isSyncingFormState = true;
    this.populateForm();
    this.syncPlatformDefaultsAcrossItems();
    this.syncPlatformValidatorsAcrossItems();
    this.resetChangesState();
    setTimeout(() => {
      this.isSyncingFormState = false;
    }, 0);
    
    this.saveButtonSubscription = this.proposalsService.saveButtonDisabled$.subscribe(
      (disabled: boolean) => {
        this.saveButtonDisabled = disabled;
      }
    );

    this.platformProfileSubscription = this.mainLayoutService.activeProfile$.subscribe(profileCode => {
      this.canSeePlatformField = profileCode
        ? this.PLATFORM_ALLOWED_PROFILES.includes(profileCode)
        : false;

      this.syncPlatformValidatorsAcrossItems();
    });
    
    setTimeout(() => {
      if (this.items && this.items.length > 0) {
        this.items.forEach((item, index) => {
          this.expandedItems[index] = false;
        });
      }
      
      this.checkDiscountWarnings();
    }, 750); 
  }

 
  private ensureLawsLoaded(jurisdictionId: string): void {
    if (!jurisdictionId) return;
    
    if (this.loadedJurisdictions.has(jurisdictionId) || this.loadingLaws[jurisdictionId]) {
      return;
    }
    
    this.loadingLaws[jurisdictionId] = true;
    
    this.proposalsService.loadLawsByJurisdiction(jurisdictionId).subscribe({
      next: (laws: any[]) => {
        this.lawsByJurisdiction[jurisdictionId] = laws.map(law => ({
          key: Number(law.key),
          value: law.value
        }));
        this.loadedJurisdictions.add(jurisdictionId);
        this.loadingLaws[jurisdictionId] = false;
        this.refreshLawsInItems(jurisdictionId);
      },
      error: (error: any) => {
        this.loadingLaws[jurisdictionId] = false;
      }
    });
  }
  
  private refreshLawsInItems(jurisdictionId: string): void {
    const formArray = this.getItemsArray();
    if (!formArray) return;
    
    formArray.controls.forEach(item => {
      const itemJurisdictionId = item.get('jurisdiction')?.value;
      
      if (itemJurisdictionId?.toString() === jurisdictionId) {
        const lawsArray = item.get('proposalItemLaws') as FormArray;
        
        if (lawsArray && lawsArray.controls.length > 0) {
          lawsArray.controls.forEach(lawControl => {
            const currentValue = lawControl.get('lawId')?.value;
            
            if (!currentValue) return;
            
           lawControl.get('lawId')?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
          });
        }
        
        item.updateValueAndValidity({ emitEvent: true });
      }
    });
  }
  
  getLawsForJurisdiction(jurisdictionId: number): { key: number; value: string }[] {
    if (!jurisdictionId) {
      return [];
    }
    
    const jurisdictionIdStr = jurisdictionId.toString();
    
    if (this.loadedJurisdictions.has(jurisdictionIdStr)) {
      const cachedLaws = this.lawsByJurisdiction[jurisdictionIdStr];
      if (cachedLaws && cachedLaws.length > 0) {
        return cachedLaws;
      }
    }
    
    if (!this.lawsByJurisdiction[jurisdictionIdStr] && !this.loadingLaws[jurisdictionIdStr]) {
      this.ensureLawsLoaded(jurisdictionIdStr);
    }
    
    return this.lawsByJurisdiction[jurisdictionIdStr] || [];
  }
  
  getItemLaws(item: any): { lawId: number | null; name: string }[] {
    const rawLaws = item?.proposalItemLaws ?? item?.laws ?? item?.proposalItemLawList ?? [];

    if (!Array.isArray(rawLaws) || rawLaws.length === 0) {
      return [];
    }

    const jurisdictionId = item?.jurisdiction?.jurisdictionId ?? item?.jurisdictionId;

    return rawLaws
      .map((entry: any) => {
        const law = entry?.law ?? entry;
        const lawId = law?.lawId !== undefined && law?.lawId !== null ? Number(law.lawId) : null;
        let name = law?.name || law?.lawName || '';

        if (!name && lawId && jurisdictionId) {
          const options = this.getLawsForJurisdiction(Number(jurisdictionId));
          name = options.find(option => option.key === lawId)?.value || '';
        }

        return { lawId, name };
      })
      .filter(law => !!law.name || law.lawId !== null);
  }

  updateLawName(lawControl: AbstractControl, itemIndex: number): void {
    const lawId = lawControl.get('lawId')?.value;
    if (!lawId) {
      return;
    }

    const laws = this.getLawOptionsForItem(itemIndex);
    const selectedLaw = laws.find(law => law.key === Number(lawId));

    if (selectedLaw) {
      lawControl.get('lawName')?.setValue(selectedLaw.value);
    }
  }


   private initialLoad: boolean = true;
  
  ngOnChanges(changes: SimpleChanges): void {
   if (changes['items'] && changes['items'].currentValue) {
      this.isSyncingFormState = true;
      this.resetChangesState();
      
      const currentUrl = window.location.href;
      const isChangeOfScope = currentUrl.includes('/proposals/change-of-scope');
      
      let items = changes['items'].currentValue;
      if (isChangeOfScope && Array.isArray(items)) {
        items = items.map(item => ({
          ...item,
          proposalItemId: null
        }));
      }
      
      this.items$.next(items);
      const formArray = this.getItemsArray();
      formArray?.clear();

      this.itemSpecificOptions = {};
      this.lawOptionsByItem = {};
      this.itemLawJurisdiction = {};
      this.lawOptionsLoadingByItem = {};

      if (this.initialLoad) {
        this.hasChanges = false;
        setTimeout(() => {
          this.initialLoad = false;
        }, 1000);
      }
      
      if (this.isOverdiscountApprovalState) {
        setTimeout(() => {
          this.checkAllOverdiscountItemsVerified();
          this.checkDiscountWarnings();
        }, 500);
      }

      if (changes['items'].currentValue.length > 0) {
        this.hasHadItems = true;
      }

      changes['items'].currentValue.forEach((item: any, index: number) => {
        const formGroup = this.createItemFormGroup(item);
        formArray?.push(formGroup);

        this.itemSpecificOptions[index] = {
          products: [],
          types: []
        };

        this.initializeFormControlSubscriptions(formGroup);

        const jurisdictionId = item.jurisdictionId || item.jurisdiction?.jurisdictionId;
        const productId = item.itemProductId || item.itemProduct?.itemProductId;

        if (jurisdictionId) {
          this.ensureLawOptionsForItem(formGroup, jurisdictionId);
          this.updateProductsAndTypes(formGroup, index, jurisdictionId, productId);
        }
      });

      const newItems = changes['items'].currentValue;
      if (newItems && newItems.length > 0) {
        this.expandedItems = {};
        newItems.forEach((_: any, index: number) => {
          this.expandedItems[index] = false;
        });

        this.syncPlatformDefaultsAcrossItems();
        this.syncPlatformValidatorsAcrossItems();
        
        setTimeout(() => {
          this.checkDiscountWarnings();
          this.resetChangesState();
          this.isSyncingFormState = false;
        }, 100);
      } else {
        this.syncPlatformDefaultsAcrossItems();
        this.syncPlatformValidatorsAcrossItems();
        this.resetChangesState();
        this.isSyncingFormState = false;
      }
    }

    this.checkAllItemsVerified();
  }

  getItemsArray(): FormArray {
    return this.formItems?.get('items') as FormArray;
  }

  addNewItem(): void {
    const newItemGroup = this.createItemFormGroup();
    const newItemIndex = this.getItemsArray().length;
    this.getItemsArray().push(newItemGroup);

    this.hasHadItems = true;

    this.ensurePlatformValueForItem(newItemGroup);
    this.updatePlatformValidatorForItem(newItemGroup);

    this.itemSpecificOptions[newItemIndex] = {
      products: [],
      types: []
    };

    this.lawOptionsByItem[newItemIndex] = [];
    this.itemLawJurisdiction[newItemIndex] = '';
    this.lawOptionsLoadingByItem[newItemIndex] = false;
    this.missingLawsByItem[newItemIndex] = false;

    this.initializeFormControlSubscriptions(newItemGroup);
  }

  addLaw(item: AbstractControl): void {
    const lawsArray = item.get('proposalItemLaws') as FormArray;
    const jurisdictionId = item.get('jurisdiction')?.value;
    const itemIndex = this.getItemIndex(item);

    if (lawsArray) {
      if (!jurisdictionId) {
        this.alertInfo = {
          show: true,
          type: 'error',
          message: 'Please select a jurisdiction first'
        };
        setTimeout(() => { this.alertInfo.show = false; }, 3000);
        return;
      }

      const existingOptions = this.getLawOptionsForItem(itemIndex);
      if (existingOptions.length > 0) {
        lawsArray.push(this.createLawFormGroup({}, jurisdictionId));
        this.missingLawsByItem[itemIndex] = false;
        this.alertInfo.show = false;
        return;
      }

      if (this.lawOptionsLoadingByItem[itemIndex]) {
        this.alertInfo = {
          show: true,
          type: 'warning',
          message: 'Loading laws for this jurisdiction... Please wait or try again in a moment.'
        };
        setTimeout(() => { this.alertInfo.show = false; }, 3000);
        return;
      }

      this.ensureLawOptionsForItem(item, jurisdictionId, (options) => {
        if (options.length > 0) {
          lawsArray.push(this.createLawFormGroup({}, jurisdictionId));
          this.missingLawsByItem[itemIndex] = false;
          this.alertInfo.show = false;
        } else {
          this.alertInfo = {
            show: true,
            type: 'warning',
            message: 'No laws available for this jurisdiction.'
          };
          setTimeout(() => { this.alertInfo.show = false; }, 3000);
        }
      });
    }
  }

  removeLaw(lawsArray: FormArray, lawIndex: number): void {
    if (lawsArray && lawsArray.length > lawIndex) {
      const lawControl = lawsArray.at(lawIndex);
      const lawId = lawControl.get('lawId')?.value;
      const lawName = lawControl.get('lawName')?.value || 'Law';
      
      lawsArray.removeAt(lawIndex);

      const itemIndex = this.getItemsArray().controls.findIndex(control => control.get('proposalItemLaws') === lawsArray);
      if (itemIndex >= 0 && lawsArray.length === 0) {
        this.missingLawsByItem[itemIndex] = true;
      }
      
      this.hasChanges = true;
      this.itemsChangedState.emit(true);
      
      this.alertNotificationService.success(`${lawName} removed successfully`);
    }
  }

  confirmDeleteLaw(item: AbstractControl, lawIndex: number): void {
    const lawsArray = item.get('proposalItemLaws') as FormArray;
    if (lawsArray && lawsArray.length > lawIndex) {
      const lawControl = lawsArray.at(lawIndex);
      const lawId = lawControl.get('lawId')?.value;
      const lawName = lawControl.get('lawName')?.value;
      
      const message = lawName 
        ? `Are you sure you want to delete the law "${lawName}"?` 
        : `Are you sure you want to delete this law?`;
        
      this.itemToBeDeleted = lawsArray;
      this.indexItemToBeDeleted = lawIndex;
      this.deleteType = 'law';
      
      this.confirmationDialogService.open(
        message,
        () => this.removeLaw(lawsArray, lawIndex)
      );
    }
  }

  removeItem(formArray: FormArray, index: number): void {
    const item = formArray.at(index) as FormGroup;
    const proposalItemId = item.get('proposalItemId')?.value;
    
    if (proposalItemId && this.proposalId) {
      this.loaderService.startLoading(this.LOADER_CONTEXT);
      
      this.proposalsService.deleteItems(this.proposalId, proposalItemId).subscribe({
        next: (response) => {       
          this.removeItemFromFormArrayAndUpdateOptions(formArray, index);
          
          this.alertNotificationService.success('Item removed successfully from database');
          this.loaderService.stopLoading(this.LOADER_CONTEXT);
        },
        error: (error) => {
          console.error(`Error deleting item ${proposalItemId}:`, error);
          this.alertNotificationService.error(
            `Error deleting item: ${error.error?.error?.message || 'Unknown error'}`
          );
          this.loaderService.stopLoading(this.LOADER_CONTEXT);
        }
      });
    } else {
      this.removeItemFromFormArrayAndUpdateOptions(formArray, index);
      this.alertNotificationService.success('Item removed successfully');
    }
  }
  
  private removeItemFromFormArrayAndUpdateOptions(formArray: FormArray, index: number): void {
    formArray.removeAt(index);

    const newItemSpecificOptions: {
      [itemId: number]: {
        products: { key: number; value: string }[];
        types: { key: number; value: string }[];
      }
    } = {};

    const newLawOptionsByItem: {
      [itemIndex: number]: { key: number; value: string }[];
    } = {};

    const newItemLawJurisdiction: { [itemIndex: number]: string } = {};
    const newLawOptionsLoadingByItem: { [itemIndex: number]: boolean } = {};

    for (let i = 0; i < formArray.length; i++) {
      if (i >= index) {
        if (this.itemSpecificOptions[i + 1]) {
          newItemSpecificOptions[i] = this.itemSpecificOptions[i + 1];
        }

        if (this.lawOptionsByItem[i + 1]) {
          newLawOptionsByItem[i] = this.lawOptionsByItem[i + 1];
        }
        if (this.itemLawJurisdiction[i + 1]) {
          newItemLawJurisdiction[i] = this.itemLawJurisdiction[i + 1];
        }
        if (this.lawOptionsLoadingByItem[i + 1]) {
          newLawOptionsLoadingByItem[i] = this.lawOptionsLoadingByItem[i + 1];
        }
      } else {
        newItemSpecificOptions[i] = this.itemSpecificOptions[i];

        if (this.lawOptionsByItem[i]) {
          newLawOptionsByItem[i] = this.lawOptionsByItem[i];
        }
        if (this.itemLawJurisdiction[i]) {
          newItemLawJurisdiction[i] = this.itemLawJurisdiction[i];
        }
        if (this.lawOptionsLoadingByItem[i]) {
          newLawOptionsLoadingByItem[i] = this.lawOptionsLoadingByItem[i];
        }
      }
    }

    this.itemSpecificOptions = newItemSpecificOptions;
    this.lawOptionsByItem = newLawOptionsByItem;
    this.itemLawJurisdiction = newItemLawJurisdiction;
    this.lawOptionsLoadingByItem = newLawOptionsLoadingByItem;
    this.alertNotificationService.success('Item removed successfully');
  }

  confirmDelete(formArray: FormArray, index: number, item: string): void {
    const message = `Are you sure you want to delete this ${item}?`;
    this.itemToBeDeleted = formArray;
    this.indexItemToBeDeleted = index;
    this.deleteType = 'item';
    
    this.confirmationDialogService.open(
      message,
      () => this.removeItem(formArray, index)
    );
  }

  selectedItem: any = null;

  openDetailsModal(item: AbstractControl): void {
    const finalPrice = Number(item?.get('finalPrice')?.value) || 0;
    const introducerRate = Number(item?.get('introducerRate')?.value) || 0;

    const introducerPrice = (introducerRate * finalPrice / 100).toFixed(2);
    const margin = (finalPrice * (100 - introducerRate) / 100).toFixed(2);

    this.selectedItem = {
      maxDiscount: item?.get('maxDiscount')?.value,
      operatingCost: item?.get('operatingCost')?.value,
      introducerName: item?.get('introducerName')?.value,
      introducerRate: introducerRate,
      introducerPrice: introducerPrice,
      margin: margin,
      finalPrice: finalPrice
    };

    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // La centratura è gestita da NgbModal (centered: true), non più a mano.
    const modalRef = this.modalService.open(this.detailsModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    const restoreScroll = () => window.scrollTo(0, scrollPosition);
    modalRef.result.then(restoreScroll, restoreScroll);
  }

  onSwitchChange(event: { isChecked: boolean; item: AbstractControl } | boolean): void {
    if (typeof event === 'boolean') {
      console.error('Unexpected boolean event without item context');
      return;
    }

    const { isChecked, item } = event;
    item.get('isVerifiedTechApproval')?.setValue(isChecked);
    
    if (!this.initialLoad) {
      this.hasChanges = true;
      this.itemsChangedState.emit(true);
      
      const allTechVerified = this.verifyTechApprovalItems();
    }
    
    this.checkAllItemsVerified();
  }
  
  onOverdiscountSwitchChange(event: { isChecked: boolean; item: AbstractControl } | boolean): void {
    if (typeof event === 'boolean') {
      console.error('Unexpected boolean event without item context');
      return;
    }

    const { isChecked, item } = event;
    item.get('isVerifiedOverdiscount')?.setValue(isChecked);
    
    if (!this.initialLoad) {
      this.hasChanges = true;
      this.itemsChangedState.emit(true);

      const allVerified = this.verifyOverdiscountItems();
    }
    
  }

  onStatusChange(newStatus: string): void {
    this.statusChange.emit(newStatus);
  }

  hasConversion(): boolean {
    return !!this.targetExchangeRate && !!this.targetCurrencyLabel;
  }

  convert(value: number | null | undefined): number {
    const converted = (Number(value) || 0) * (this.targetExchangeRate || 0);
    return Math.round(converted * 100) / 100;
  }

  formatConverted(value: number | null | undefined): string {
    return this.convert(value).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  private createItemFormGroup(item: any = {}): FormGroup {
    const itemId = item?.itemId || 
                  item?.item?.itemId || 
                  item?.itemProduct?.item?.itemId ||
                  null;
    
    
    const formGroup = this.fb.group({
      itemId: [itemId],
      proposalItemId: [item?.proposalItemId || null],
      proposalId: [item?.proposal?.proposalId || null],
      verificed: [item?.isVerified || false],
      isVerifiedTechApproval: [item?.isVerifiedTechApproval || false],
      isVerifiedOverdiscount: [item?.isVerifiedOverdiscount || false],
      jurisdiction: [item?.jurisdiction?.jurisdictionId || '', Validators.required],
      itemProduct: [item?.itemProduct?.itemProductId || item?.itemProductId || '', Validators.required],
      itemType: [item?.itemType?.itemTypeId || item?.itemTypeId || '', Validators.required],
      platformId: [
        item?.platform?.platformId || item?.platformId || '',
        this.canSeePlatformField ? Validators.required : []
      ],
      quantity: [item?.quantity || 1, Validators.required],
      effort: [item?.effort || 100, Validators.required],
      price: [{ value: item?.price, disabled: false }, Validators.required],
      detail: [item?.detail || '', ],
      rankSale: [item?.rankSale || 0, Validators.required],
      discountPercent: [item?.discountPercent || 0, Validators.required],
      campaignId: [item?.campaign?.campaignId || '', ],
      finalPrice: [{ value: item?.finalPrice, disabled: true }, Validators.required],
      maxDiscount: [item?.maxDiscount || 0],
      operatingCost: [item?.operatingCost || 0],
      introducerName: [item?.introducer?.name || ''],
      introducerRate: [item?.introducerPercent || 0],
      introducerPrice: [item?.introducerValue || 0],
      margin: [item?.marginValue || 0],
      overdiscountReason: [item?.overdiscountReason],
      proposalItemLaws: this.fb.array(
        Array.isArray(item?.proposalItemLaws)
          ? item.proposalItemLaws.map((lawObj: any) => this.createLawFormGroup(lawObj.law, item?.jurisdiction?.jurisdictionId, lawObj?.proposalItemLawId))
          : Array.isArray(item?.laws)
            ? item.laws.map((law: any) => this.createLawFormGroup(law, item?.jurisdiction?.jurisdictionId))
            : []
      ),
    });

    if (!item?.campaign?.campaignId) {
      this.itemMaxDiscountBaseline.set(formGroup, item?.maxDiscount || 0);
    }

    return formGroup;
  }

  private syncPlatformValidatorsAcrossItems(): void {
    const itemsArray = this.getItemsArray();
    if (!itemsArray?.controls?.length) {
      return;
    }

    itemsArray.controls.forEach(control => this.updatePlatformValidatorForItem(control));
  }

  private syncPlatformDefaultsAcrossItems(): void {
    const itemsArray = this.getItemsArray();
    if (!itemsArray?.controls?.length) {
      return;
    }

    itemsArray.controls.forEach(control => this.ensurePlatformValueForItem(control));
  }

  private ensurePlatformValueForItem(itemControl: AbstractControl): void {
    if (this.platformOptions.length === 0) {
      return;
    }

    const platformControl = itemControl.get('platformId');
    if (!platformControl) {
      return;
    }

    const currentValue = platformControl.value;
    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      return;
    }

    const defaultPlatformKey = this.platformOptions[0]?.key;
    if (defaultPlatformKey === null || defaultPlatformKey === undefined || defaultPlatformKey === '') {
      return;
    }

    platformControl.setValue(defaultPlatformKey);
  }

  private updatePlatformValidatorForItem(itemControl: AbstractControl): void {
    const platformControl = itemControl.get('platformId');
    if (!platformControl) {
      return;
    }

    if (this.canSeePlatformField) {
      platformControl.setValidators([Validators.required]);
    } else {
      platformControl.clearValidators();
    }

    this.ensurePlatformValueForItem(itemControl);
    platformControl.updateValueAndValidity({ emitEvent: false });
  }

  private createLawFormGroup(law: any = {}, jurisdictionId?: number, proposalItemLawId?:number): FormGroup {
    const lawName = law?.name || law?.lawName || '';
    
    return this.fb.group({
      lawId: [law?.lawId ? Number(law.lawId) : ''],
      lawName: [lawName],
      jurisdictionId: [law?.jurisdictionId || jurisdictionId || null],
      proposalItemLawId: [proposalItemLawId || '']
    });
  }

  private populateForm(): void {
    const formArray = this.getItemsArray();
    formArray.clear();

    this.itemSpecificOptions = {};

    if (this.items && this.items.length > 0) {
      this.items.forEach((item, index) => {
        item.isVerifiedTechApproval = item.isVerifiedTechApproval || false;
        
        const jurisdictionId = item.jurisdictionId || item.jurisdiction?.jurisdictionId;
        
        const formGroup = this.createItemFormGroup(item);
        formArray.push(formGroup);

        this.itemSpecificOptions[index] = {
          products: item.itemProduct
            ? [{ key: item.itemProduct.itemProductId, value: item.itemProduct.code }]
            : [],
          types: item.itemType
            ? [{ key: item.itemType.itemTypeId, value: item.itemType.code || item.itemType.name }]
            : []
        };

        this.initializeFormControlSubscriptions(formGroup);

        if (jurisdictionId) {
          const productId = item.itemProductId || item.itemProduct?.itemProductId;
          this.ensureLawOptionsForItem(formGroup, jurisdictionId);
          this.updateProductsAndTypes(formGroup, index, jurisdictionId, productId);
        }

        if (item?.campaign?.campaignId) {
          this.fetchMaxDiscountBaseline(formGroup);
        }
      });
    }
  }

  private initializeFormControlSubscriptions(formGroup: FormGroup): void {
    const jurisdictionControl = formGroup.get('jurisdiction');
    const productControl = formGroup.get('itemProduct');
    const typeControl = formGroup.get('itemType');
    const platformControl = formGroup.get('platformId');
    const quantityControl = formGroup.get('quantity');
    const priceControl = formGroup.get('price');
    const discountControl = formGroup.get('discountPercent');
    const promoControl = formGroup.get('campaignId');
    const maxDiscountControl = formGroup.get('maxDiscount');
    const finalPriceControl = formGroup.get('finalPrice');
    const lawsArray = formGroup.get('proposalItemLaws') as FormArray;
    
    formGroup.valueChanges.subscribe(() => {
      if (this.isSyncingFormState || this.initialLoad) {
        return;
      }

      if (!this.hasChanges) {
        this.hasChanges = true;
        this.itemsChangedState.emit(true);
      }
    });

    if (jurisdictionControl) {
      jurisdictionControl.valueChanges.subscribe(value => {
        this.setLawOptionsForItem(formGroup, value);
      });
    }

    if (productControl) {
      productControl.valueChanges.subscribe(value => {
        if (value) {
          this.onProductChange(formGroup);
        }
      });
    }
    
    if (typeControl) {
      typeControl.valueChanges.subscribe(typeId => {
        if (typeId && jurisdictionControl && productControl && platformControl) {
          const jurisdictionId = jurisdictionControl.value;
          const productId = productControl.value;
          const platformId = platformControl.value;
          
          if (jurisdictionId && productId && platformId) {
            this.fetchItemIdFromApi(formGroup, jurisdictionId, productId, typeId, platformId);
          }
        }
      });
    }
    
    if (platformControl) {
      platformControl.valueChanges.subscribe(platformId => {
        if (platformId && jurisdictionControl && productControl && typeControl) {
          const jurisdictionId = jurisdictionControl.value;
          const productId = productControl.value;
          const typeId = typeControl.value;
          
          if (jurisdictionId && productId && typeId) {
            this.fetchItemIdFromApi(formGroup, jurisdictionId, productId, typeId, platformId);
          }
        }
      });
    }

    if (discountControl) {
      discountControl.valueChanges.subscribe(() => {
        setTimeout(() => {
          this.checkDiscountWarnings();
        });
      });
    }
    
    if (promoControl) {
      promoControl.valueChanges.subscribe((promoId) => {
        this.applyPromoDiscount(formGroup, promoId);
        this.applyMaxDiscountForItem(formGroup);
        setTimeout(() => {
          this.checkDiscountWarnings();
        });
        this.formItems.updateValueAndValidity();
      });
    }
    
    const updateFinalPrice = () => {
      if (quantityControl && priceControl && discountControl && finalPriceControl) {
        const quantity = Number(quantityControl.value) || 0;
        const price = Number(priceControl.value) || 0;
        const discount = Number(discountControl.value) || 0;
        const introducerRateControl = formGroup.get('introducerRate');
        const introducerPriceControl = formGroup.get('introducerPrice');
        const marginControl = formGroup.get('margin');
        const introducerRate = Number(introducerRateControl?.value) || 0;

        const calculatedFinalPrice = price * quantity * (100 - discount) / 100;
        const roundedFinalPrice = Math.round(calculatedFinalPrice * 100) / 100;

        if (finalPriceControl.value !== roundedFinalPrice) {
          finalPriceControl.setValue(roundedFinalPrice, { emitEvent: false });

          if (introducerPriceControl && marginControl) {
            const calculatedIntroducerPrice = roundedFinalPrice * introducerRate / 100;
            const roundedIntroducerPrice = Math.round(calculatedIntroducerPrice * 100) / 100;
            introducerPriceControl.setValue(roundedIntroducerPrice, { emitEvent: false });

            const calculatedMargin = roundedFinalPrice * (100 - introducerRate) / 100;
            const roundedMargin = Math.round(calculatedMargin * 100) / 100;
            marginControl.setValue(roundedMargin, { emitEvent: false });
          }
        }
      }
    };

    if (quantityControl) {
      quantityControl.valueChanges.subscribe(() => updateFinalPrice());
    }

    if (priceControl) {
      priceControl.valueChanges.subscribe(() => updateFinalPrice());
    }

    if (discountControl) {
      discountControl.valueChanges.subscribe(() => {
        updateFinalPrice();
        this.updateDiscountJustificationValidators(formGroup);
        this.formItems.updateValueAndValidity();
      });
    }

    

    const introducerRateControl = formGroup.get('introducerRate');
    if (introducerRateControl && finalPriceControl) {
      introducerRateControl.valueChanges.subscribe(() => {
        const introducerRate = Number(introducerRateControl.value) || 0;
        const finalPrice = Number(finalPriceControl.value) || 0;
        const introducerPriceControl = formGroup.get('introducerPrice');
        const marginControl = formGroup.get('margin');

        if (introducerPriceControl && marginControl) {
          const calculatedIntroducerPrice = finalPrice * introducerRate / 100;
          const roundedIntroducerPrice = Math.round(calculatedIntroducerPrice * 100) / 100;
          introducerPriceControl.setValue(roundedIntroducerPrice, { emitEvent: false });

          const calculatedMargin = finalPrice * (100 - introducerRate) / 100;
          const roundedMargin = Math.round(calculatedMargin * 100) / 100;
          marginControl.setValue(roundedMargin, { emitEvent: false });
        }
      });
    }

    updateFinalPrice();
  }

  private applyPromoDiscount(formGroup: FormGroup, promoId: string | number | null | undefined): void {
    const discountControl = formGroup.get('discountPercent');
    if (!discountControl) {
      return;
    }

    if (!promoId) {
      discountControl.setValue(0, { emitEvent: true });
      return;
    }

    const campaignDetails = this.campaignsDetails[promoId.toString()];
    if (campaignDetails) {
      discountControl.setValue(campaignDetails.discountPercent ?? 0, { emitEvent: true });
    }
  }

  private applyMaxDiscountForItem(formGroup: FormGroup): void {
    const maxDiscountControl = formGroup.get('maxDiscount');
    if (!maxDiscountControl) {
      return;
    }

    const promoId = formGroup.get('campaignId')?.value;
    if (promoId) {
      const campaignDetails = this.campaignsDetails[promoId.toString()];
      if (campaignDetails) {
        maxDiscountControl.setValue(campaignDetails.discountPercent ?? 0, { emitEvent: false });
      }
      return;
    }

    if (this.itemMaxDiscountBaseline.has(formGroup)) {
      maxDiscountControl.setValue(this.itemMaxDiscountBaseline.get(formGroup) ?? 0, { emitEvent: false });
    } else {
      this.fetchMaxDiscountBaseline(formGroup);
    }
  }

  private fetchMaxDiscountBaseline(formGroup: FormGroup): void {
    const jurisdictionId = formGroup.get('jurisdiction')?.value;
    const productId = formGroup.get('itemProduct')?.value;
    const typeId = formGroup.get('itemType')?.value;
    const platformId = formGroup.get('platformId')?.value;

    if (!jurisdictionId || !productId || !typeId || !platformId) {
      return;
    }

    const params = new HttpParams()
      .set('jurisdictionId', jurisdictionId.toString())
      .set('itemProductId', productId.toString())
      .set('itemTypeId', typeId.toString())
      .set('platformId', platformId.toString())
      .set('size', '9999');

    this.itemsService.list({ params }).subscribe({
      next: (response: any) => {
        const matchingItem = response?.data?.items?.[0];
        const baseline = matchingItem?.maxDiscountPercent || 0;
        this.itemMaxDiscountBaseline.set(formGroup, baseline);
        this.applyMaxDiscountForItem(formGroup);
      },
      error: (error: any) => {
        console.error('Error retrieving item max discount baseline:', error);
      }
    });
  }

 
  private fetchItemIdFromApi(formGroup: FormGroup, jurisdictionId: string | number, 
                            productId: string | number, typeId: string | number,
                            platformId: string | number): void {

    this.loaderService.startLoading(this.LOADER_CONTEXT);
    
    const params = new HttpParams()
      .set('jurisdictionId', jurisdictionId.toString())
      .set('itemProductId', productId.toString())
      .set('itemTypeId', typeId.toString())
      .set('platformId', platformId.toString())
      .set('size', '9999');
    
    this.itemsService.list({ params }).subscribe({
      next: (response: any) => {
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
        
        if (response?.data?.items && response.data.items.length > 0) {
          const matchingItem = response.data.items[0]; 
          
          
          formGroup.patchValue({
            itemId: matchingItem.itemId,
            price: matchingItem.price || 0,
            operatingCost: matchingItem.operatingCost || 0,
            introducerRate: matchingItem.introducerPercent || 0
          });

          this.itemMaxDiscountBaseline.set(formGroup, matchingItem.maxDiscountPercent || 0);
          this.applyMaxDiscountForItem(formGroup);

          this.updateCalculatedFields(formGroup);
          
        } else {
          console.warn('No items found with the selected criteria');
          this.alertNotificationService.warning('No items found with the selected criteria');
        }
      },
      error: (error: any) => {
        console.error('Error retrieving item data:', error);
        this.alertNotificationService.error(`Error retrieving item data: ${error.error?.error?.message || 'Unknown error'}`);
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
      }
    });
  }
 
  private updateCalculatedFields(formGroup: FormGroup): void {
    const quantityControl = formGroup.get('quantity');
    const priceControl = formGroup.get('price');
    const discountControl = formGroup.get('discountPercent');
    const finalPriceControl = formGroup.get('finalPrice');
    const introducerRateControl = formGroup.get('introducerRate');
    const introducerPriceControl = formGroup.get('introducerPrice');
    const marginControl = formGroup.get('margin');
    
    if (quantityControl && priceControl && discountControl && finalPriceControl) {
      const quantity = Number(quantityControl.value) || 0;
      const price = Number(priceControl.value) || 0;
      const discount = Number(discountControl.value) || 0;
      const introducerRate = Number(introducerRateControl?.value) || 0;

      const calculatedFinalPrice = price * quantity * (100 - discount) / 100;
      const roundedFinalPrice = Math.round(calculatedFinalPrice * 100) / 100;

      finalPriceControl.setValue(roundedFinalPrice, { emitEvent: false });

      if (introducerPriceControl && marginControl) {
        const calculatedIntroducerPrice = roundedFinalPrice * introducerRate / 100;
        const roundedIntroducerPrice = Math.round(calculatedIntroducerPrice * 100) / 100;
        introducerPriceControl.setValue(roundedIntroducerPrice, { emitEvent: false });

        const calculatedMargin = roundedFinalPrice * (100 - introducerRate) / 100;
        const roundedMargin = Math.round(calculatedMargin * 100) / 100;
        marginControl.setValue(roundedMargin, { emitEvent: false });
      }
    }
  }

  getFormControl(group: AbstractControl, controlName: string): FormControl {
    const control = group.get(controlName);
    if (!(control instanceof FormControl)) {
      throw new Error(`Control '${controlName}' is not a FormControl.`);
    }
    return control;
  }

  getFormArray(group: AbstractControl, controlName: string): FormArray {
    const control = group.get(controlName);
    if (!(control instanceof FormArray)) {
      throw new Error(`Control '${controlName}' is not a FormArray.`);
    }
    return control;
  }

  getNestedFormControl(control: AbstractControl, controlName: string): FormControl {
    const nestedControl = control.get(controlName);
    if (!(nestedControl instanceof FormControl)) {
      throw new Error(`Nested control '${controlName}' is not a FormControl.`);
    }
    return nestedControl;
  }

  /**
 * *******************
 * Submit form methods
 * *******************
 */
  scrollToComponentTop(behavior: ScrollBehavior = 'smooth', offset: number = 20) {
    if (this.proposalItemsContainer && this.proposalItemsContainer.nativeElement) {
      const elementPosition = this.proposalItemsContainer.nativeElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: behavior
      });
    }
  }

  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    };
    
    if (type === 'success') {
      this.alertNotificationService.success(message);
    } else {
      setTimeout(() => {
        this.scrollToComponentTop();
      }, 10);
    }
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.formItems);
    this.formService.setValidationErrors(this.formItems, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.initialLoad = false;
    
    const allOverdiscountVerified = this.verifyOverdiscountItems();
    const allTechApprovalVerified = this.isTechApprovalState ? this.verifyTechApprovalItems() : true;
    
    this.resetChangesState();
    
    if (this.isOverdiscountApprovalState) {
      this.overdiscountVerificationChanged.emit(allOverdiscountVerified);
    }
    
    if (this.isTechApprovalState) {
      this.techApprovalVerificationChanged.emit(allTechApprovalVerified);
    }
    
    this.onSavedData.emit({
      success: true,
      response: {
        ...response,
        allOverdiscountVerified,
        allTechApprovalVerified: this.isTechApprovalState ? allTechApprovalVerified : true
      }
    });
  }

  private resetChangesState(): void {
    this.hasChanges = false;
    this.itemsChangedState.emit(false);

    if (this.formItems) {
      this.formItems.markAsPristine();
      this.formItems.markAsUntouched();
    }
  }

  submitFormError(error: any) {
    if (error.error?.error?.description === 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error?.error?.description === 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error?.error?.message || 'An error occurred during processing');
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  validateLawsBeforeSubmit(): boolean {
    const formArray = this.getItemsArray();
    let isValid = true;
    const errorMessages: string[] = [];

    if (!formArray || !formArray.controls || formArray.controls.length === 0) {
      return true;
    }

    this.missingLawsByItem = {};

    formArray.controls.forEach((itemControl, itemIndex) => {
      const lawsArray = itemControl.get('proposalItemLaws') as FormArray;

      if (!lawsArray || lawsArray.length === 0) {
        isValid = false;
        this.missingLawsByItem[itemIndex] = true;
        errorMessages.push(`Item ${itemIndex + 1} has no laws associated. Please add at least one law.`);
        return;
      }

      this.missingLawsByItem[itemIndex] = false;

      lawsArray.controls.forEach((lawControl, lawIndex) => {
        const lawId = lawControl.get('lawId')?.value;

        if (!lawId) {
          isValid = false;
          errorMessages.push(`Item ${itemIndex + 1} has an invalid law at position ${lawIndex + 1}. The law ID is missing.`);
        }
      });
    });

    if (!isValid) {
      const errorMessage = errorMessages.join('<br>');
      this.alertInfo = {
        show: true,
        type: 'danger',
        message: errorMessage
      };

      this.alertNotificationService.error('Operation failed: some items have no valid laws.');

      setTimeout(() => {
        this.scrollToComponentTop();
      }, 10);
    }

    return isValid;
  }

  submitForm(): void {
  this.syncPlatformDefaultsAcrossItems();
  this.syncPlatformValidatorsAcrossItems();

  Object.keys(this.formItems.controls).forEach(key => {
    const control = this.formItems.get(key);
    control?.markAsTouched();
    control?.updateValueAndValidity();
  });
  const lawsValid = this.validateLawsBeforeSubmit();

  let invalidFields: string[] = [];
  const itemsArray = this.getItemsArray();
  itemsArray.controls.forEach((item, index) => {
    Object.keys((item as FormGroup).controls).forEach(field => {
      if((item as FormGroup).get(field)?.invalid) {
        invalidFields.push(`Item ${index + 1}: ${field}`);
      }
    });
  });
  
  if (!this.formItems.valid || !lawsValid) {
    this.alertInfo = {
      show: true,
      type: 'danger',
      message: `Form is invalid. Please check the following fields: ${invalidFields.join(', ')}`
    };
    this.alertNotificationService.error(`Operation failed: the form has errors in the following fields: ${invalidFields.join(', ')}`);
    
    setTimeout(() => {
      this.scrollToComponentTop();
    }, 10);
    return;
  }
  const formItemsValue = this.formItems.getRawValue().items.map((item: any) => {
    if (!item.itemId) {
      console.warn('itemId missing or null for item:', item);
    }
    
    const overdiscountReason = item.overdiscountReason || item.discountJustification || '';
    
    return {
      ...item,
      overdiscountReason,
      isVerifiedTechApproval: !!item.isVerifiedTechApproval,
      isVerifiedOverdiscount: !!item.isVerifiedOverdiscount,
      proposalItemLaws: item.proposalItemLaws,
      proposalId: this.proposalId,
      tenantId: 1,
    };
  });

  this.alertInfo.show = false;
  this.formService.resetErrors(this.formItems);
  
  this.loaderService.startLoading(this.LOADER_CONTEXT);
  
  this.processItemsSequentially(formItemsValue, 0)
    .then(result => {
      this.loaderService.stopLoading(this.LOADER_CONTEXT);
      this.showAlertInfo('success', `Successfully saved ${result.successes} items.`);
      
      if (result.successes > 0) {
        this.submitFormSuccess(result.responses);
      }
      
      if (result.errors.length > 0) {        
        this.submitFormError(result.errors[0]);
        this.showAlertInfo('danger', `Saved ${result.successes} items, but encountered ${result.errors.length} errors.`);
      }
    })
    .catch(error => {
      this.loaderService.stopLoading(this.LOADER_CONTEXT);
      this.showAlertInfo('danger', `Failed to save items: ${error.message || 'Unknown error'}`);
      this.submitFormError(error);
    });
}

private processItemsSequentially(items: any[], currentIndex: number): Promise<{successes: number, responses: any[], errors: any[]}> {
  return new Promise((resolve, reject) => {
    const results = {
      successes: 0,
      responses: [] as any[],
      errors: [] as any[]
    };
    
    const processNext = (index: number) => {
      if (index >= items.length) {
        this.hasChanges = false;
        
        const allOverdiscountVerified = this.isOverdiscountApprovalState ? 
          items.every(item => item.isVerifiedOverdiscount === true) : false;
        
        const allTechApprovalVerified = this.isTechApprovalState ? 
          items.every(item => item.isVerifiedTechApproval === true) : false;
        
        if (this.isOverdiscountApprovalState) {
          this.overdiscountVerificationChanged.emit(allOverdiscountVerified);
        }
        
        if (this.isTechApprovalState) {
          this.techApprovalVerificationChanged.emit(allTechApprovalVerified);
        }
        
        resolve(results);
        return;
      }
      
      const item = { ...items[index] };
      
      if (item.proposalItemLaws && Array.isArray(item.proposalItemLaws)) {
        const lawIdsObjects = item.proposalItemLaws.map((law: any) => ({
          lawId: Number(law.lawId)
        }));
        
        const originalMapping = item.proposalItemLaws.map((law: any) => {
          return {
            lawId: Number(law.lawId),
            proposalItemLawId: law.proposalItemLawId,
            jurisdictionId: Number(law.jurisdictionId) 
          };
        });
        
        if (item.proposalItemId) {
          item.proposalItemLaws = lawIdsObjects;
        } else {
          item.proposalItemLaws = originalMapping;
        }
      }
      
      let apiCall;
      if (item.proposalItemId) {
        apiCall = this.proposalsService.updateItems(this.proposalId, item.proposalItemId, item);
      } else {
        apiCall = this.proposalsService.createItems(this.proposalId, item);
      }
      
      apiCall.subscribe({
        next: (response: any) => {
          results.responses.push(response);
          results.successes++;
          processNext(index + 1);
        },
        error: (error: any) => {
          console.error(`Error processing item ${index + 1}:`, error);
          const enhancedError = {
            ...error,
            itemIndex: index,
            processedItems: results.successes,
            totalItems: items.length,
            affectedItem: item
          };
          
          results.errors.push(enhancedError);
          
          processNext(index + 1);
        }
      });
    };
    
    processNext(currentIndex);
  });
}


  ngOnDestroy(): void {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    
    if (this.saveButtonSubscription) {
      this.saveButtonSubscription.unsubscribe();
    }

    if (this.profileSubscription) {
      this.profileSubscription.unsubscribe();
    }

    if (this.platformProfileSubscription) {
      this.platformProfileSubscription.unsubscribe();
    }
    
    this.loaderService.stopLoading(this.LOADER_CONTEXT);
  }

  private checkAllItemsVerified(): void {
    const formArray = this.getItemsArray();
    const allItemsVerified = formArray?.controls?.every(control => control.get('isVerifiedTechApproval')?.value === true);

    this.verificationChanged.emit(allItemsVerified);
    
    if (this.isTechApprovalState) {
      this.techApprovalVerificationChanged.emit(allItemsVerified);
    }
  }
  
  verifyOverdiscountItems(): boolean {
    const formArray = this.getItemsArray();
    
    if (!formArray || !formArray.controls || formArray.controls.length === 0) {
     return true;
    }
    
    const itemsWithDiscountWarning = formArray.controls.filter(control => this.isDiscountWarning(control));
    
    if (!itemsWithDiscountWarning || itemsWithDiscountWarning.length === 0) {
      if (this.isOverdiscountApprovalState) {
        this.overdiscountVerificationChanged.emit(true);
      }
      return true;
    }
    
    const allOverdiscountVerified = itemsWithDiscountWarning.every(
      control => control.get('isVerifiedOverdiscount')?.value === true
    );
    
    if (this.isOverdiscountApprovalState) {
      this.overdiscountVerificationChanged.emit(allOverdiscountVerified);
      
      if (allOverdiscountVerified) {
        this.itemsChangedState.emit(false);
      }
    }
    
    return allOverdiscountVerified;
  }

  verifyTechApprovalItems(): boolean {
    const formArray = this.getItemsArray();
    
    if (!formArray || !formArray.controls || formArray.controls.length === 0) {
      this.techApprovalVerificationChanged.emit(true);
      return true;
    }
    
    if (!this.isTechApprovalState) {
      this.techApprovalVerificationChanged.emit(true);
      return true;
    }
    
    const allTechApprovalVerified = formArray.controls.every(
      control => control.get('isVerifiedTechApproval')?.value === true
    );
    
    this.techApprovalVerificationChanged.emit(allTechApprovalVerified);
  
    if (allTechApprovalVerified && this.isTechApprovalState) {
      this.itemsChangedState.emit(false);
    }
    
    return allTechApprovalVerified;
  }

  private checkAllOverdiscountItemsVerified(): void {
    const formArray = this.getItemsArray();
    
    if (!formArray || !formArray.controls || formArray.controls.length === 0) {
      this.overdiscountVerificationChanged.emit(true);
      return;
    }
    
    const itemsWithDiscountWarning = formArray.controls.filter(control => this.isDiscountWarning(control));
    
    if (!itemsWithDiscountWarning || itemsWithDiscountWarning.length === 0) {
      this.overdiscountVerificationChanged.emit(true);
      return;
    }
    
    const allOverdiscountVerified = itemsWithDiscountWarning.every(
      control => control.get('isVerifiedOverdiscount')?.value === true
    );

    this.overdiscountVerificationChanged.emit(allOverdiscountVerified);
  }

  toggleItemDetails(index: number): void {
    this.expandedItems[index] = !this.expandedItems[index];
  }

  isItemExpanded(index: number): boolean {
    return this.expandedItems[index] || false;
  }

  calculateTotal(): number {
    if (!this.items || this.items.length === 0) {
      return 0;
    }

    return this.items.reduce((total, item) => {
      const finalPrice = item.finalPrice ? parseFloat(item.finalPrice) : 0;
      return total + finalPrice;
    }, 0);
  }

  private getItemIndex(item: AbstractControl): number {
    const formArray = this.getItemsArray();
    return formArray.controls.indexOf(item);
  }

  getProductOptionsForItem(index: number): { key: number; value: string }[] {
    return this.itemSpecificOptions[index]?.products || this.itemProductsOptions;
  }

  getTypeOptionsForItem(index: number): { key: number; value: string }[] {
    return this.itemSpecificOptions[index]?.types || this.itemTypesOptions;
  }

  getLawOptionsForItem(index: number): { key: number; value: string }[] {
    return this.lawOptionsByItem[index] || [];
  }

  private clearLawsArray(item: AbstractControl): void {
    const lawsArray = item.get('proposalItemLaws') as FormArray;
    if (!lawsArray) {
      return;
    }

    while (lawsArray.length > 0) {
      lawsArray.removeAt(0);
    }
  }

  private ensureLawOptionsForItem(
    item: AbstractControl,
    jurisdictionId: number | string,
    onLoaded?: (options: { key: number; value: string }[]) => void
  ): void {
    this.setLawOptionsForItem(item, jurisdictionId, onLoaded);
  }

  private setLawOptionsForItem(
    item: AbstractControl,
    jurisdictionId?: number | string | null,
    onLoaded?: (options: { key: number; value: string }[]) => void
  ): void {
    const itemIndex = this.getItemIndex(item);
    if (itemIndex < 0) {
      return;
    }

    if (!jurisdictionId) {
      this.lawOptionsByItem[itemIndex] = [];
      this.itemLawJurisdiction[itemIndex] = '';
      this.clearLawsArray(item);
      onLoaded?.([]);
      return;
    }

    const jurisdictionIdStr = jurisdictionId.toString();
    const hasSameJurisdiction = this.itemLawJurisdiction[itemIndex] === jurisdictionIdStr;
    const existingOptions = this.lawOptionsByItem[itemIndex];

    if (hasSameJurisdiction && existingOptions && existingOptions.length > 0) {
      this.syncItemLawsWithOptions(item, existingOptions, jurisdictionId);
      onLoaded?.(existingOptions);
      return;
    }

    if (this.lawOptionsLoadingByItem[itemIndex]) {
      return;
    }

    this.lawOptionsLoadingByItem[itemIndex] = true;

    this.proposalsService.loadLawsByJurisdiction(jurisdictionIdStr).subscribe({
      next: (laws: any[]) => {
        const mapped = laws.map(law => ({
          key: Number(law.key),
          value: law.value
        }));
        this.lawOptionsByItem[itemIndex] = mapped;
        this.itemLawJurisdiction[itemIndex] = jurisdictionIdStr;
        this.lawOptionsLoadingByItem[itemIndex] = false;
        this.syncItemLawsWithOptions(item, mapped, jurisdictionId);
        onLoaded?.(mapped);
      },
      error: (error: any) => {
        console.error('Error loading laws:', error);
        this.lawOptionsLoadingByItem[itemIndex] = false;
        onLoaded?.([]);
      }
    });
  }

  private syncItemLawsWithOptions(
    item: AbstractControl,
    options: { key: number; value: string }[],
    jurisdictionId?: number | string
  ): void {
    const lawsArray = item.get('proposalItemLaws') as FormArray;
    if (!lawsArray) {
      return;
    }

    const jurisdictionValue = jurisdictionId ? Number(jurisdictionId) : null;
    for (let i = lawsArray.length - 1; i >= 0; i--) {
      const lawControl = lawsArray.at(i);
      const lawId = Number(lawControl.get('lawId')?.value);
      const match = options.find(option => option.key === lawId);

      if (jurisdictionValue !== null) {
        lawControl.get('jurisdictionId')?.setValue(jurisdictionValue, { emitEvent: false });
      }

      if (lawId && !match) {
        lawsArray.removeAt(i);
      } else if (match) {
        lawControl.get('lawName')?.setValue(match.value, { emitEvent: false });
      }
    }
  }

  hasLawsForJurisdiction(jurisdictionId: number): boolean {
    if (!jurisdictionId) {
      return false;
    }
    const filteredLaws = this.lawsOptions.filter(law => law.jurisdictionId === parseInt(jurisdictionId.toString()));
    return filteredLaws.length > 0;
  }

  isDiscountWarning(item: AbstractControl): boolean {
    if (!item) return false;

    const discountControl = item.get('discountPercent');
    const maxDiscountControl = item.get('maxDiscount');

    if (!discountControl) return false;

    return this.proposalsService.isOverDiscount({
      discount: discountControl.value,
      maxDiscount: maxDiscountControl?.value
    });
  }
  
  
  checkDiscountWarnings(): void {
    const formArray = this.getItemsArray();
    if (!formArray) return;
    
    let hasDiscountWarnings = false;
    let allJustified = true;
    
    formArray.controls.forEach(control => {
      this.updateDiscountJustificationValidators(control as FormGroup);
      
      const hasWarning = this.isDiscountWarning(control);
      if (hasWarning) {
        hasDiscountWarnings = true;
        
        const justificationControl = control.get('overdiscountReason');
        const justificationValue = justificationControl?.value || '';
        const isJustified = justificationValue.trim() !== '';
        
        if (!isJustified) {
          allJustified = false;
        }
      }
    });
    
    
    if (hasDiscountWarnings) {
      this.discountWarningChanged.emit({ hasWarning: hasDiscountWarnings, allJustified: allJustified });
      
      if (this.isOverdiscountApprovalState) {
        this.checkAllOverdiscountItemsVerified();
      }
    } else {
      this.discountWarningChanged.emit({ hasWarning: false, allJustified: true });
    }
  }
  
  updateDiscountJustificationValidators(formGroup: FormGroup): void {
    const discountControl = formGroup.get('discountPercent');
    const justificationControl = formGroup.get('overdiscountReason');
    
    if (discountControl && justificationControl) {
      const isWarning = this.isDiscountWarning(formGroup);
      
      if (isWarning) {
        justificationControl.setValidators(Validators.required);
      } else {
        justificationControl.clearValidators();
      }
      
      justificationControl.updateValueAndValidity();
    }
  }


  openDiscountNoteModal(item: AbstractControl): void {
    this.currentItemWithWarning = item;
    const discountControl = item.get('discountPercent');
    const promoControl = item.get('campaignId');

    const discountValue = Number(discountControl?.value) || 0;
    const promoId = promoControl?.value;

    this.discountWarningData = {
      currentDiscount: discountValue,
      itemIndex: this.getItemIndex(item),
      maxDiscount: Number(item.get('maxDiscount')?.value) || 0
    };

    const campaignDetails = promoId ? this.campaignsDetails[promoId] : undefined;
    if (campaignDetails) {
      this.discountWarningData.campaignName = campaignDetails.name;
    }

    const overdiscountValue = item.get('overdiscountReason')?.value;
    this.discountJustification = overdiscountValue || '';

    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // La centratura è gestita da NgbModal (centered: true), non più a mano.
    this.discountNoteModalRef = this.modalService.open(this.discountNoteModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    const restoreScroll = () => {
      this.discountNoteModalRef = undefined;
      window.scrollTo(0, scrollPosition);
    };
    this.discountNoteModalRef.result.then(restoreScroll, restoreScroll);
  }

  requestDiscountApproval(): void {
    if (!this.discountJustification || !this.currentItemWithWarning) {
      this.alertNotificationService.error('You must provide a justification to request approval');
      return;
    }

    const justificationField = this.currentItemWithWarning.get('overdiscountReason');
    if (justificationField) {
      justificationField.setValue(this.discountJustification);
      justificationField.markAsDirty();
      justificationField.updateValueAndValidity();
    } else {
      (this.currentItemWithWarning as FormGroup).addControl(
        'overdiscountReason',
        new FormControl(this.discountJustification)
      );
    }

    this.alertNotificationService.success('Approval request successfully sent');
    
    setTimeout(() => {
      this.checkDiscountWarnings();
    });

    this.discountNoteModalRef?.dismiss();
    this.discountNoteModalRef = undefined;
  }

  private updateProductsAndTypes(item: AbstractControl, index: number, jurisdictionId: any, productId?: any): void {
    this.proposalsService.getItemProductsByJurisdiction(jurisdictionId).subscribe({
      next: (itemProducts: any[]) => {
        const mappedProducts = itemProducts.map((itemProduct: any) => ({
          key: itemProduct.key,
          value: itemProduct.value
        }));
        this.itemSpecificOptions[index].products = mappedProducts;
        if (productId) {
          this.proposalsService.getItemTypesByJurisdictionAndProduct(jurisdictionId, productId).subscribe({
            next: (itemTypes: any) => {
              const mappedTypes = itemTypes.map((itemType: any) => ({
                key: itemType.key,
                value: itemType.value
              }));
              this.itemSpecificOptions[index].types = mappedTypes;
            },
            error: (error: any) => {
              console.error('Error loading types for jurisdiction and product:', error);
              this.alertNotificationService.error('Error loading types for the selected combination');
            }
          });
        }
      },
      error: (error: any) => {
        console.error('Error loading products for jurisdiction:', error);
        this.alertNotificationService.error('Error loading products for the selected jurisdiction');
      }
    });
  }

  onJurisdictionChange(item: AbstractControl): void {
    const jurisdictionControl = item.get('jurisdiction');
    const productControl = item.get('itemProduct');
    const typeControl = item.get('itemType');
    const itemIndex = this.getItemIndex(item);
    
    if (jurisdictionControl) {
      const jurisdictionId = jurisdictionControl.value;
      productControl?.setValue('');
      typeControl?.setValue('');
      
      if (jurisdictionId) {
        this.clearLawsArray(item);
        this.setLawOptionsForItem(item, jurisdictionId);
        
        if (!this.itemSpecificOptions[itemIndex]) {
          this.itemSpecificOptions[itemIndex] = { products: [], types: [] };
        }
        
        this.updateProductsAndTypes(item, itemIndex, jurisdictionId);
      } else {
        this.setLawOptionsForItem(item, null);
      }
    }
  }

  onProductChange(item: AbstractControl): void {
    const jurisdictionControl = item.get('jurisdiction');
    const productControl = item.get('itemProduct');
    const typeControl = item.get('itemType');
    const itemIndex = this.getItemIndex(item);
    
    if (jurisdictionControl && productControl && typeControl) {
      const jurisdictionId = jurisdictionControl.value;
      const productId = productControl.value;
      typeControl.setValue('');
      
      if (!this.itemSpecificOptions[itemIndex]) {
        this.itemSpecificOptions[itemIndex] = { products: [], types: [] };
      }
      
      if (jurisdictionId && productId) {
        this.updateProductsAndTypes(item, itemIndex, jurisdictionId, productId);
      }
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}